import { render } from "./MyMontyHomepage.vue?vue&type=template&id=009d11ea"
import script from "./MyMontyHomepage.vue?vue&type=script&lang=js"
export * from "./MyMontyHomepage.vue?vue&type=script&lang=js"

import "./MyMontyHomepage.vue?vue&type=style&index=0&id=009d11ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__